// StyledToggleButtonLabel.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledToggleButtonLabelBase = styled.label`
  outline: none;
  font-size: ${({ styling }) => `${styling.toggleLabelFontSize}px`};
  font-weight: ${({ styling }) => styling.toggleLabelFontWeight};
  font-family: ${({ styling }) => styling.toggleLabelFontFamily};
  transition: ${(props) => props.theme.transitionMain};
  color: ${({ styling }) => styling.toggleLabelColor};
`;

const StyledToggleButtonLabel = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledToggleButtonLabelBase {...props} placeholder={placeholderText} />;
};



export default StyledToggleButtonLabel;
